<template>
  <Timeline>
    <TimelineItem
      v-for="(item, idx) in itemlist"
      :key="idx"
    >
      <p class="time" @click="popTime( item.time, idx )">{{ item.time }}</p>
      <p class="time-content" @click="popTime( item.time, idx )">{{ item.content }}</p>
      <p class="time-tags" v-if="item.tags && item.tags.length"><Tag fade v-for="(tag, i) in item.tags" :key="i">{{ tag }}</Tag></p>
    </TimelineItem>
    <!-- <Modal v-model="showModel" draggable scrollable footer-hide title="Modal 2" width="830">
        <infos-card></infos-card>
      <div>This is the second modal + {{ itemlist[selectIdx].time }}</div>
    </Modal> -->
  </Timeline>
</template>
<script>
import InfosCard from '@/components/profile/infos-card.vue'
export default {
    components: {
      InfosCard  
    },
  props: {
    items: {
      type: Array,
      default: n => []
    },
    reverse: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      showModel: false,
      selectIdx: 0
    };
  },
  methods: {
    popTime(time, idx) {
        this.mStore.updateResume(time, idx);
    }
  },
  computed: {
    itemlist: function() {
      return this.reverse ? this.items.reverse() : this.items;
    }
  }
};
</script>
<style>
.time {
  font-weight: bolder;
  cursor: pointer;
}
.time-content {
  cursor: pointer;
}
.time-tags {
    max-width: 250px;
}
.ivu-timeline-item-tail {
  margin-left: 50%;
}
.ivu-timeline-item-head {
  margin-left: 50%;
}
.ivu-timeline-item:nth-child(odd) > .ivu-timeline-item-content {
  padding-left: calc(50% + 24px);
  text-align: start;
}
.ivu-timeline-item:nth-child(even) > .ivu-timeline-item-content .time-tags {
    margin-left: auto;
}
.ivu-timeline-item:nth-child(even) > .ivu-timeline-item-content {
  padding-right: calc(50% + 10px);
  text-align: end;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/nCenterTimeLine.vue